import PropertySearchFilter from './filters';
import { OfferTypeForHoliday } from './offer-types';

function updateLocationFiltersState( form: HTMLFormElement ): void {
    const financeSection: HTMLElement | null = form.querySelector( '#location-filter-category-finance' );

    if ( !financeSection ) {
        return;
    }

    const filter: PropertySearchFilter = PropertySearchFilter.fromForm( form );

    switch ( filter.offer ) {
    case OfferTypeForHoliday:
        financeSection.classList.add( 'd-none' );

        [
            'minUrbanIBI',
            'maxUrbanIBI',
        ].forEach( ( name: string ) => {
            const filterElement: HTMLSelectElement | null = form.querySelector( `[name=${name}]` );

            if ( !filterElement ) {
                throw new Error( `failed to find selector [name=${name}]` );
            }

            filterElement.value = '';
            filterElement.classList.remove( 'has-value' );
        } );

        break;
    default:
        financeSection.classList.remove( 'd-none' );
    }
}

function updateFilterCallToActionButtonsVisibility( form: HTMLFormElement ): void {
    const locationID = form.querySelector<HTMLInputElement>( '.searchpopup__location input[name="locationId"]' );
    const isFindYourPlace = !!locationID && locationID.value.startsWith( 'location-filters' );
    const isCustomArea = !!locationID && [ 'draw-your-search', 'map-area' ].includes( locationID.value );
    const findYourPlaceCTA = document.querySelector( '#location-search-cta-fyp' ) as HTMLAnchorElement;

    if ( findYourPlaceCTA && ( isFindYourPlace ) ) {
        const submitBtns = form.querySelectorAll( 'button[type="submit"][data-destination="location"]' );
        submitBtns.forEach( ( btn: HTMLButtonElement ) => btn.classList.remove( 'd-none' ) );
        findYourPlaceCTA.classList.remove( 'searchpopup__locationcta--hidden' );
    }

    if ( findYourPlaceCTA && !isFindYourPlace ) {
        findYourPlaceCTA.classList.add( 'searchpopup__locationcta--hidden' );
    }

    const drawYourSearchCTA = document.querySelector( '#location-search-cta-dys' ) as HTMLAnchorElement;

    if ( drawYourSearchCTA && isCustomArea ) {
        drawYourSearchCTA.classList.remove( 'searchpopup__locationcta--hidden' );
    }

    if ( drawYourSearchCTA && !isCustomArea ) {
        drawYourSearchCTA.classList.add( 'searchpopup__locationcta--hidden' );
    }
}

export {
    updateLocationFiltersState,
    updateFilterCallToActionButtonsVisibility,
};
